import * as React from "react";
import { Stack, Typography, Switch } from "@mui/material";

interface Props {
  onFilterChange: (showActiveOnly: boolean) => void;
  showActiveOnly?: boolean;
}

const AppBundleFilter: React.FC<Props> = ({ onFilterChange, showActiveOnly = true }) => {
  const handleSwitchChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onFilterChange(!event.target.checked);
    },
    [onFilterChange]
  );

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography variant="body2" color="text.secondary">
        Show:
      </Typography>
      <Typography variant="body2" color={showActiveOnly ? "text.primary" : "text.secondary"}>
        Active
      </Typography>
      <Switch checked={!showActiveOnly} onChange={handleSwitchChange} size="small" color="primary" />
      <Typography variant="body2" color={showActiveOnly ? "text.secondary" : "text.primary"}>
        All
      </Typography>
    </Stack>
  );
};

export { AppBundleFilter };
